module.exports = __webpack_public_path__ + "static/media/q3.fde0bbad.md";